import {Space, Text} from 'platform/foundation';

import {Nullish, TestIdProps} from 'shared/web';

export interface HelperTextProps extends TestIdProps {
  helperText?: string | Nullish;
  errorMessage?: string | Nullish;
  /**
   * @about
   * Target of the input's `aria-describedby`, so assistive technology announces this text
   * together with the field.
   */
  id?: string;
}

export function HelperText(props: HelperTextProps) {
  const isInvalid = !!props.errorMessage;
  const textColor = isInvalid ? 'danger' : 'tertiary';

  return (
    <>
      <Space vertical={1} />
      <Text id={props.id} size="xSmall" color={textColor} data-testid={props['data-testid']}>
        {props.errorMessage || props.helperText}
      </Text>
    </>
  );
}
